export const WIDGET_MIN_WIDTH = 300;
export const WIDGET_MIN_HEIGHT = 400;
export const DOCKED_WIDGET_WIDTH = 500;
const VIEWPORT_EDGE_GUTTER_PX = 32;
const VIEWPORT_TOP_GUTTER_PX = 100;
const PILL_VIEWPORT_TOP_GUTTER_PX = 25;
export const clampWidgetSize = ({
  width,
  height,
  browserWindowWidth,
  browserWindowHeight,
  usePillLauncher
}) => {
  const topGutter = usePillLauncher ? PILL_VIEWPORT_TOP_GUTTER_PX : VIEWPORT_TOP_GUTTER_PX;
  return {
    width: Math.max(WIDGET_MIN_WIDTH, Math.min(width, browserWindowWidth - VIEWPORT_EDGE_GUTTER_PX)),
    height: Math.max(WIDGET_MIN_HEIGHT, Math.min(height, browserWindowHeight - topGutter))
  };
};